@if (open) {
<div class="perfil-intro-modal" role="dialog" aria-modal="true"
  [attr.aria-labelledby]="'perfil-intro-title-' + seccionId" (click)="onBackdrop($event)">
  <div class="perfil-intro-modal__panel" (click)="$event.stopPropagation()">
    <header class="perfil-intro-modal__header">
      <div class="perfil-intro-modal__titles">
        <h2 class="perfil-intro-modal__title" [id]="'perfil-intro-title-' + seccionId">
          {{ modal.titulo }}
        </h2>
        <p class="perfil-intro-modal__intro">{{ modal.intro }}</p>
      </div>
      <button type="button" class="perfil-intro-modal__close" aria-label="Cerrar" (click)="onClose()">
        <span class="material-icons" aria-hidden="true">close</span>
      </button>
    </header>

    <div class="perfil-intro-modal__body">
      <ul class="perfil-intro-modal__list">
        @for (item of modal.items; track item.icon + '-' + $index) {
        <li class="perfil-intro-modal__item">
          <span class="perfil-intro-modal__icon" aria-hidden="true">
            <img [src]="iconSrc(item.icon)" alt="" width="56" height="56" />
          </span>
          <p class="perfil-intro-modal__item-text">
            @for (part of item.parts; track $index) {
            <span class="perfil-intro-modal__item-part" [class.perfil-intro-modal__item-em]="!!part.em">{{ part.text
              }}</span>
            }
          </p>
        </li>
        }
      </ul>

      <aside class="perfil-intro-modal__tip">
        <p class="perfil-intro-modal__tip-title">{{ copy.modalIntro.tipTitle }}</p>
        <p class="perfil-intro-modal__tip-body">{{ copy.modalIntro.tipBody }}</p>
      </aside>
    </div>

    <button type="button" class="perfil-intro-modal__cta" [id]="'btn-perfil-intro-completar-' + seccionId"
      (click)="onCompletar()">
      {{ copy.modalIntro.ctaCompletarDatos }}
    </button>
  </div>
</div>
}